import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const TextInput = ({
  name,
  label,
  classes,
  onChange,
  placeholder,
  value,
  error,
  disabled,
  textArea,
  tooltip
}) => {
  const wrapperClass = `form-group ${error && error.length ? 'has-error' : ''}`;
  const inputClass = `form-control ${error && error.length ? 'has-error' : ''}`;
  const placement = "right";

  const field = textArea ? (
    <textarea
      name={name}
      className={inputClass}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  ) : (
    <input
      type="text"
      name={name}
      className={inputClass}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );

  const fieldLabel =
    label &&
    (tooltip ? (
      <OverlayTrigger placement={placement} trigger="click" overlay={<Tooltip id={name} className={placement}>{tooltip}</Tooltip>}>
        <label htmlFor={name} className={classes}>
          {label}
        </label>
      </OverlayTrigger>
    ) : (
      <label htmlFor={name} className={classes}>
        {label}
      </label>
    ));

  return (
    <div className={wrapperClass}>
      {fieldLabel}
      <div className="field">
        {field}
        {error && <div className="alert alert-danger help-block">{error}</div>}
      </div>
    </div>
  );
};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  classes: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  textArea: PropTypes.bool,
  tooltip: PropTypes.string
};

export default TextInput;
